import React from 'react'
import SubHeader from '../../../../../component/common/layout/SubHeader'
import SurveyListHeader from '../../../../../component/common/layout/SurveyListHeader'
import SurveyListSidebar from '../../../../../component/common/layout/SurveyListSidebar';
import quesdesignimg from "../../../../../assets/images/ques-design-bg1.jpg";
import quesdesignimg2 from "../../../../../assets/images/ques-design-bg2.jpg";
import quesdesignimg3 from "../../../../../assets/images/ques-design-bg3.jpg";
import quesdesignimg4 from "../../../../../assets/images/ques-design-bg4.jpg";
import quesdesignimg5 from "../../../../../assets/images/ques-design-bg5.jpg";
import quesdesignimg6 from "../../../../../assets/images/ques-design-bg6.jpg";
import quesdesignimg7 from "../../../../../assets/images/ques-design-bg7.jpg";
import quesdesignimg8 from "../../../../../assets/images/ques-design-bg8.jpg";
import logo1 from "../../../../../assets/images/logo-upload1.svg";
import logo2 from "../../../../../assets/images/logo-upload2.svg";
import Svg from '../../../../../component/common/Svg';
import previewIndex from '../preview/Index';
import style from "../../../../style.module.css";
import MultipleQuestions from '../preview/MultipleQuestions';
import Preview from "../preview/Index";
import TopHeading from '../preview/TopHeading';
import SearchInput from '../../../../../core/Inputs/SearchInput';
import { useDevice } from "../../../../customHooks";
import { EditTextarea } from 'react-edit-text';
import Card from '../../../../../core/Card';
import Callout from '../../../../../core/Callout';
import { Icon } from '@blueprintjs/core';
import Typography from '../../../../../core/Typography';
import Input from "../../../../../core/Inputs/DefaultInput";
import Tooltip from '../../../../../core/Tooltip';
import { useState, useEffect } from 'react';
import Button from '../../../../../core/Button';
import PreviewFooter from '../preview/PreviewFooter';
import { Link } from 'react-router-dom';
export default function Index(props) {
    const { view, color, pos, isOpen } = props;
    const canEditSurveyDesign = window.modulePermissions.M12.edit == 1;
    let device = useDevice();
    const flexDirection = device === "mobile" ? "column" : "row";
    const alignItems = device === "mobile" ? "flex-start" : "initial";
    return (
        <>
            <div id="content" className="flex-grow-1 dashboard-page-outer">
                <SubHeader />
                <div className="survey-design-container d-flex">

                    {/**New Sidebar Code */}
                    <div className="design-sidebar">

                        <div className="design-default-sidebar">
                            {/* breadcrumbs here */}
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/admin/survey/list">Survey</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="#">Survey Name</a>
                                    </li>
                                    
                                    <li className="breadcrumb-item active" aria-current="page">
                                        <strong>Design</strong>
                                    </li>
                                </ol>
                            </nav>
                            {/* breadcrumbs ends here */}


                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">Themes</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Custom Design</button>
                                </li>

                            </ul>
                            <div className="tab-content" id="myTabContent">
                                <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                    <div className="side-tab-wrapper">
                                        <div className="gx-3 row">
                                            <div className="col-md-12">

                                                <div className="search-area"><div>
                                                    <SearchInput className="w-100"
                                                        type="def"
                                                        view="outlined"
                                                        color="default"
                                                        value=""
                                                        placeholder="Search themes"
                                                        fill={device === "mobile"}
                                                        style={device !== "mobile" && { width: "250px" }}
                                                        disabled={!canEditSurveyDesign}
                                                    />
                                                </div>
                                                </div>
                                                <h3>Previous survey templates</h3>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="ques-panel " >
                                                    <a href="#">
                                                        <div className="panel-box " >
                                                            <div className="panel-box-top" style={{ backgroundImage: `url(${quesdesignimg})` }}>
                                                                <h5>Question</h5>
                                                                <div className="ans-text">Answer</div>
                                                                <div className="colorarea  " style={{ backgroundColor: "#0077B6" }}></div>
                                                            </div>

                                                            <div className="panel-bot d-flex justify-content-between align-items-center">
                                                                <a href="#">Arrow</a>
                                                                <div className="dropdown">
                                                                    <button className="btn dropdown-tgl" type="button" id="options" data-bs-toggle="dropdown"
                                                                        aria-haspopup="true" aria-expanded="false">
                                                                        <svg width={21} height={3} viewBox="0 0 21 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <circle cx="1.5" cy="1.5" r="1.5" transform="rotate(-90 1.5 1.5)" fill="black" />
                                                                            <circle cx="10.5" cy="1.5" r="1.5" transform="rotate(-90 10.5 1.5)" fill="black" />
                                                                            <circle cx="19.5" cy="1.5" r="1.5" transform="rotate(-90 19.5 1.5)" fill="black" />
                                                                        </svg>
                                                                    </button>
                                                                    <div className="dropdown-menu dropdown-menu-end" aria-labelledby="options">
                                                                        <a className="dropdown-item" href="#">Edit</a>
                                                                        <a className="dropdown-item" href="#">Duplicate</a>
                                                                        <a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#deleteModal">Delete</a>
                                                                    </div>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="ques-panel " >
                                                    <a href="#">
                                                        <div className="panel-box " >
                                                            <div className="panel-box-top" style={{ backgroundImage: `url(${quesdesignimg2})` }}>
                                                                <h5>Question</h5>
                                                                <div className="ans-text">Answer</div>
                                                                <div className="colorarea blue" style={{ backgroundColor: "#0F2744" }}></div>
                                                            </div>
                                                            <div className="panel-bot d-flex justify-content-between align-items-center">
                                                                <a href="#">Rose bud</a>
                                                                <div className="dropdown">
                                                                    <button className="btn dropdown-tgl" type="button" id="options" data-bs-toggle="dropdown"
                                                                        aria-haspopup="true" aria-expanded="false">
                                                                        <svg width={21} height={3} viewBox="0 0 21 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <circle cx="1.5" cy="1.5" r="1.5" transform="rotate(-90 1.5 1.5)" fill="black" />
                                                                            <circle cx="10.5" cy="1.5" r="1.5" transform="rotate(-90 10.5 1.5)" fill="black" />
                                                                            <circle cx="19.5" cy="1.5" r="1.5" transform="rotate(-90 19.5 1.5)" fill="black" />
                                                                        </svg>
                                                                    </button>
                                                                    <div className="dropdown-menu dropdown-menu-end" aria-labelledby="options">
                                                                        <a className="dropdown-item" href="#">Edit</a>
                                                                        <a className="dropdown-item" href="#">Duplicate</a>
                                                                        <a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#deleteModal">Delete</a>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="ques-panel " >
                                                    <a href="#">
                                                        <div className="panel-box " >
                                                            <div className="panel-box-top" style={{ backgroundImage: `url(${quesdesignimg3})` }}>
                                                                <h5>Question</h5>
                                                                <div className="ans-text">Answer</div>
                                                                <div className="colorarea blue" style={{ backgroundColor: "#774936" }}></div>
                                                            </div>
                                                            <div className="panel-bot d-flex justify-content-between align-items-center">
                                                                <a href="#">Calm</a>
                                                                <div className="dropdown">
                                                                    <button className="btn dropdown-tgl" type="button" id="options" data-bs-toggle="dropdown"
                                                                        aria-haspopup="true" aria-expanded="false">
                                                                        <svg width={21} height={3} viewBox="0 0 21 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <circle cx="1.5" cy="1.5" r="1.5" transform="rotate(-90 1.5 1.5)" fill="black" />
                                                                            <circle cx="10.5" cy="1.5" r="1.5" transform="rotate(-90 10.5 1.5)" fill="black" />
                                                                            <circle cx="19.5" cy="1.5" r="1.5" transform="rotate(-90 19.5 1.5)" fill="black" />
                                                                        </svg>
                                                                    </button>
                                                                    <div className="dropdown-menu dropdown-menu-end" aria-labelledby="options">
                                                                        <a className="dropdown-item" href="#">Edit</a>
                                                                        <a className="dropdown-item" href="#">Duplicate</a>
                                                                        <a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#deleteModal">Delete</a>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="ques-panel " >
                                                    <a href="#">
                                                        <div className="panel-box " >
                                                            <div className="panel-box-top" style={{ backgroundImage: `url(${quesdesignimg4})` }}>
                                                                <h5>Question</h5>
                                                                <div className="ans-text">Answer</div>
                                                                <div className="colorarea blue" style={{ backgroundColor: "#fff" }}></div>
                                                            </div>
                                                            <div className="panel-bot d-flex justify-content-between align-items-center">
                                                                <a href="#">Candy</a>
                                                                <div className="dropdown">
                                                                    <button className="btn dropdown-tgl" type="button" id="options" data-bs-toggle="dropdown"
                                                                        aria-haspopup="true" aria-expanded="false">
                                                                        <svg width={21} height={3} viewBox="0 0 21 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <circle cx="1.5" cy="1.5" r="1.5" transform="rotate(-90 1.5 1.5)" fill="black" />
                                                                            <circle cx="10.5" cy="1.5" r="1.5" transform="rotate(-90 10.5 1.5)" fill="black" />
                                                                            <circle cx="19.5" cy="1.5" r="1.5" transform="rotate(-90 19.5 1.5)" fill="black" />
                                                                        </svg>
                                                                    </button>
                                                                    <div className="dropdown-menu dropdown-menu-end" aria-labelledby="options">
                                                                        <a className="dropdown-item" href="#">Edit</a>
                                                                        <a className="dropdown-item" href="#">Duplicate</a>
                                                                        <a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#deleteModal">Delete</a>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </a>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <button className="btn btn-bordered  w-100 ">Load more</button>
                                            </div>
                                            <div className="col-md-12">
                                                <h3>Survey templates</h3>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="ques-panel " >
                                                    <a href="#">
                                                        <div className="panel-box " >
                                                            <div className="panel-box-top" style={{ backgroundImage: `url(${quesdesignimg5})` }}>
                                                                <h5>Question</h5>
                                                                <div className="ans-text">Answer</div>
                                                                <div className="colorarea blue" style={{ backgroundColor: "#6A8EE1" }}></div>
                                                            </div>

                                                            <div className="panel-bot d-flex justify-content-between align-items-center">
                                                                <a href="#">Default theme</a>
                                                                <div className="dropdown">
                                                                    <button className="btn dropdown-tgl" type="button" id="options" data-bs-toggle="dropdown"
                                                                        aria-haspopup="true" aria-expanded="false">
                                                                        <svg width={21} height={3} viewBox="0 0 21 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <circle cx="1.5" cy="1.5" r="1.5" transform="rotate(-90 1.5 1.5)" fill="black" />
                                                                            <circle cx="10.5" cy="1.5" r="1.5" transform="rotate(-90 10.5 1.5)" fill="black" />
                                                                            <circle cx="19.5" cy="1.5" r="1.5" transform="rotate(-90 19.5 1.5)" fill="black" />
                                                                        </svg>
                                                                    </button>
                                                                    <div className="dropdown-menu dropdown-menu-end" aria-labelledby="options">
                                                                        <a className="dropdown-item" href="#">Edit</a>
                                                                        <a className="dropdown-item" href="#">Duplicate</a>
                                                                        <a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#deleteModal">Delete</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="ques-panel " >
                                                    <a href="#">
                                                        <div className="panel-box " >
                                                            <div className="panel-box-top" style={{ backgroundImage: `url(${quesdesignimg6})` }}>
                                                                <h5>Question</h5>
                                                                <div className="ans-text">Answer</div>
                                                                <div className="colorarea blue" style={{ backgroundColor: "#792896" }}></div>
                                                            </div>

                                                            <div className="panel-bot d-flex justify-content-between align-items-center">
                                                                <a href="#">Orchid</a>
                                                                <div className="dropdown">
                                                                    <button className="btn dropdown-tgl" type="button" id="options" data-bs-toggle="dropdown"
                                                                        aria-haspopup="true" aria-expanded="false">
                                                                        <svg width={21} height={3} viewBox="0 0 21 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <circle cx="1.5" cy="1.5" r="1.5" transform="rotate(-90 1.5 1.5)" fill="black" />
                                                                            <circle cx="10.5" cy="1.5" r="1.5" transform="rotate(-90 10.5 1.5)" fill="black" />
                                                                            <circle cx="19.5" cy="1.5" r="1.5" transform="rotate(-90 19.5 1.5)" fill="black" />
                                                                        </svg>
                                                                    </button>
                                                                    <div className="dropdown-menu dropdown-menu-end" aria-labelledby="options">
                                                                        <a className="dropdown-item" href="#">Edit</a>
                                                                        <a className="dropdown-item" href="#">Duplicate</a>
                                                                        <a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#deleteModal">Delete</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="ques-panel " >
                                                    <a href="#">
                                                        <div className="panel-box " >
                                                            <div className="panel-box-top" style={{ backgroundImage: `url(${quesdesignimg7})` }}>
                                                                <h5>Question</h5>
                                                                <div className="ans-text">Answer</div>
                                                                <div className="colorarea blue" style={{ backgroundColor: "#0D5492" }}></div>
                                                            </div>
                                                            <div className="panel-bot d-flex justify-content-between align-items-center">
                                                                <a href="#">Ocean</a>
                                                                <div className="dropdown">
                                                                    <button className="btn dropdown-tgl" type="button" id="options" data-bs-toggle="dropdown"
                                                                        aria-haspopup="true" aria-expanded="false">
                                                                        <svg width={21} height={3} viewBox="0 0 21 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <circle cx="1.5" cy="1.5" r="1.5" transform="rotate(-90 1.5 1.5)" fill="black" />
                                                                            <circle cx="10.5" cy="1.5" r="1.5" transform="rotate(-90 10.5 1.5)" fill="black" />
                                                                            <circle cx="19.5" cy="1.5" r="1.5" transform="rotate(-90 19.5 1.5)" fill="black" />
                                                                        </svg>
                                                                    </button>
                                                                    <div className="dropdown-menu dropdown-menu-end" aria-labelledby="options">
                                                                        <a className="dropdown-item" href="#">Edit</a>
                                                                        <a className="dropdown-item" href="#">Duplicate</a>
                                                                        <a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#deleteModal">Delete</a>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="ques-panel " >
                                                    <a href="#">
                                                        <div className="panel-box " >
                                                            <div className="panel-box-top" style={{ backgroundImage: `url(${quesdesignimg8})` }}>
                                                                <h5>Question</h5>
                                                                <div className="ans-text">Answer</div>
                                                                <div className="colorarea blue" style={{ backgroundColor: "#0F2744" }}></div>
                                                            </div>
                                                            <div className="panel-bot d-flex justify-content-between align-items-center">
                                                                <a href="#">Grassland</a>
                                                                <div className="dropdown">
                                                                    <button className="btn dropdown-tgl" type="button" id="options" data-bs-toggle="dropdown"
                                                                        aria-haspopup="true" aria-expanded="false">
                                                                        <svg width={21} height={3} viewBox="0 0 21 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <circle cx="1.5" cy="1.5" r="1.5" transform="rotate(-90 1.5 1.5)" fill="black" />
                                                                            <circle cx="10.5" cy="1.5" r="1.5" transform="rotate(-90 10.5 1.5)" fill="black" />
                                                                            <circle cx="19.5" cy="1.5" r="1.5" transform="rotate(-90 19.5 1.5)" fill="black" />
                                                                        </svg>
                                                                    </button>
                                                                    <div className="dropdown-menu dropdown-menu-end" aria-labelledby="options">
                                                                        <a className="dropdown-item" href="#">Edit</a>
                                                                        <a className="dropdown-item" href="#">Duplicate</a>
                                                                        <a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#deleteModal">Delete</a>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                    <div className="side-tab-wrapper">
                                        <div className="gx-3 row">
                                            <div className="col-md-12">
                                                <div className="theme-name">Theme - Rose bud </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="logo-edit">
                                                    <div className="text-small-gray">Logo </div>
                                                    <div className="box-edit">
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Logo 1</div>
                                                            <div class="image-upload">

                                                                <div className="border-divider"></div>
                                                                <input type="file" id="upload" hidden />
                                                                <button data-bs-toggle="modal" data-bs-target="#addFile" className='fileUpload btn btn-bordered'>Add </button>
                                                            </div>
                                                        </div>
                                                        <div className="divider-edit"></div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Logo 2</div>
                                                            <div class="image-upload">

                                                                <div className="border-divider"></div>
                                                                <input type="file" id="upload" hidden />
                                                                <button data-bs-toggle="modal" data-bs-target="#addFile" className='fileUpload btn btn-bordered'>Add </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* Logo1 Edit start */}
                                                    <div className="box-edit">
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Logo 1</div>
                                                            <div className="d-flex align-items-center justify-content-end">
                                                                <div className="action-wrapper d-flex tooltipsBtns">

                                                                    <Tooltip
                                                                        view={view}
                                                                        color='primary'
                                                                        content="Change picture"
                                                                        position='top'
                                                                        // isOpen={isOpen ? isOpen : null}
                                                                        className='black-tooltip'
                                                                    >
                                                                        <button data-bs-toggle="modal" data-bs-target="#addFile" className='btn   action-btn'><Svg name="gallery-black" /></button>
                                                                    </Tooltip>
                                                                    <Tooltip
                                                                        view={view}
                                                                        color='primary'
                                                                        content="Delete picture"
                                                                        position='top'
                                                                        // isOpen={isOpen ? isOpen : null}
                                                                        className='black-tooltip'
                                                                    >
                                                                        <button type="button" className="btn   action-btn" data-bs-toggle="modal" data-bs-target="#editPins" srno="1" value="1"><Svg name="delete" /></button>
                                                                    </Tooltip>

                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="logoPosition  d-flex justify-content-between align-items-center">
                                                            <div className="leftLogo">
                                                                <img src={logo1} alt="Logo" />
                                                            </div>

                                                            <div className='survey-format-dropdown d-flex justify-content-between align-items-center'>
                                                                <div class="info-text surveyDesign">Position</div>
                                                                <div className="btn-group">
                                                                    <div class="selectBox">

                                                                        <div className="select-type d-flex align-items-center">
                                                                            <select className="form-control fontFamily" >
                                                                                <option>Top center</option>
                                                                                <option>Top left</option>
                                                                                <option>Top right</option>
                                                                            </select>
                                                                        </div>


                                                                    </div>
                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div className="divider-edit"></div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Logo 2</div>
                                                            <div className="d-flex align-items-center justify-content-end">
                                                                <div className="action-wrapper d-flex tooltipsBtns">

                                                                    <Tooltip
                                                                        view={view}
                                                                        color='primary'
                                                                        content="Change picture"
                                                                        position='top'
                                                                        // isOpen={isOpen ? isOpen : null}
                                                                        className='black-tooltip'
                                                                    >
                                                                        <button type="button" className="btn  action-btn " data-bs-toggle="modal" data-bs-target="#addFile" srno="1" value="1"><Svg name="gallery-black" /></button>

                                                                    </Tooltip>
                                                                    <Tooltip
                                                                        view={view}
                                                                        color='primary'
                                                                        content="Delete picture"
                                                                        position='top'
                                                                        // isOpen={isOpen ? isOpen : null}
                                                                        className='black-tooltip'
                                                                    >
                                                                        <button type="button" className="btn  action-btn" data-bs-toggle="modal" data-bs-target="#editPins" srno="1" value="1"><Svg name="delete" /></button>
                                                                    </Tooltip>

                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="logoPosition  d-flex justify-content-between align-items-center">
                                                            <div className="leftLogo">
                                                                <img src={logo2} alt="Logo" />
                                                            </div>

                                                            <div className='survey-format-dropdown d-flex justify-content-between align-items-center'>
                                                                <div class="info-text surveyDesign">Position</div>
                                                                <div className="btn-group">
                                                                    <div class="selectBox">

                                                                        <div className="select-type d-flex align-items-center">
                                                                            <select className="form-control fontFamily" >
                                                                                <option>Top center</option>
                                                                                <option>Top left</option>
                                                                                <option>Top right</option>
                                                                            </select>
                                                                        </div>


                                                                    </div>
                                                                </div>

                                                            </div>

                                                        </div>

                                                    </div>
                                                    {/* Logo Edit end */}
                                                    <div className="text-small-gray">TEXT </div>
                                                    <div className="box-edit">
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font</div>
                                                            <div class="selectBox">

                                                                <div className="select-type d-flex align-items-center">
                                                                    <select className="form-control fontFamily" >
                                                                        <option>Open sans</option>
                                                                        <option>Arial</option>
                                                                        <option>Gotham</option>
                                                                    </select>
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div className="divider-edit"></div>
                                                        <div className="bold-gray-title">Survey title</div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font size</div>
                                                            <div class="selectBox">

                                                                <div className="select-type d-flex align-items-center">
                                                                    <select className="form-control  " >
                                                                        <option>10</option>
                                                                        <option>20</option>
                                                                        <option>30</option>
                                                                        <option>40</option>
                                                                    </select>
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font weight</div>
                                                            <div class="selectBox">

                                                                <div className="select-type d-flex align-items-center">
                                                                    <select className="form-control  " >
                                                                        <option>Regular</option>
                                                                        <option>Medium</option>
                                                                        <option>Bold</option>
                                                                    </select>
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font color</div>
                                                            <div class="selectBox">

                                                                <div className="colorPick d-flex align-items-center">
                                                                    <input type="color" className='PickColor' />
                                                                    {/* <input type="color" className='PickColor'   value="#774936" /> */}
                                                                </div>


                                                            </div>
                                                        </div>

                                                        <div className="divider-edit"></div>
                                                        <div className="bold-gray-title">Description</div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font size</div>
                                                            <div class="selectBox">

                                                                <div className="select-type d-flex align-items-center">
                                                                    <select className="form-control  " >
                                                                        <option>10</option>
                                                                        <option>20</option>
                                                                        <option>30</option>
                                                                        <option>40</option>
                                                                    </select>
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font weight</div>
                                                            <div class="selectBox">

                                                                <div className="select-type d-flex align-items-center">
                                                                    <select className="form-control  " >
                                                                        <option>Regular</option>
                                                                        <option>Medium</option>
                                                                        <option>Bold</option>
                                                                    </select>
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font color</div>
                                                            <div class="selectBox">

                                                                <div className="colorPick d-flex align-items-center">
                                                                    <input type="color" className='PickColor' />
                                                                    {/* <input type="color" className='PickColor'   value="#774936" /> */}
                                                                </div>


                                                            </div>
                                                        </div>

                                                        <div className="divider-edit"></div>
                                                        <div className="bold-gray-title">Question</div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font size</div>
                                                            <div class="selectBox">

                                                                <div className="select-type d-flex align-items-center">
                                                                    <select className="form-control  " >
                                                                        <option>10</option>
                                                                        <option>20</option>
                                                                        <option>30</option>
                                                                        <option>40</option>
                                                                    </select>
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font weight</div>
                                                            <div class="selectBox">

                                                                <div className="select-type d-flex align-items-center">
                                                                    <select className="form-control  " >
                                                                        <option>Regular</option>
                                                                        <option>Medium</option>
                                                                        <option>Bold</option>
                                                                    </select>
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font color</div>
                                                            <div class="selectBox">

                                                                <div className="colorPick d-flex align-items-center">
                                                                    <input type="color" className='PickColor' />
                                                                    {/* <input type="color" className='PickColor'   value="#774936" /> */}
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div className="divider-edit"></div>
                                                        <div className="bold-gray-title">Options</div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font size</div>
                                                            <div class="selectBox">

                                                                <div className="select-type d-flex align-items-center">
                                                                    <select className="form-control  " >
                                                                        <option>10</option>
                                                                        <option>20</option>
                                                                        <option>30</option>
                                                                        <option>40</option>
                                                                    </select>
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font weight</div>
                                                            <div class="selectBox">

                                                                <div className="select-type d-flex align-items-center">
                                                                    <select className="form-control  " >
                                                                        <option>Regular</option>
                                                                        <option>Medium</option>
                                                                        <option>Bold</option>
                                                                    </select>
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font color</div>
                                                            <div class="selectBox">

                                                                <div className="colorPick d-flex align-items-center">
                                                                    <input type="color" className='PickColor' />
                                                                    {/* <input type="color" className='PickColor'   value="#774936" /> */}
                                                                </div>


                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="text-small-gray">Background </div>
                                                    <div className="box-edit">
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Background color</div>
                                                            <div class="clrPkr">

                                                                <div className="colorPick d-flex align-items-center">
                                                                    <input type="color" className='PickColor' />
                                                                    {/* <input type="color" className='PickColor'   value="#774936" /> */}
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div className="divider-edit"></div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Background image</div>
                                                            <div class="image-upload">

                                                                <div className="border-divider"></div>
                                                                <input type="file" id="upload" hidden />
                                                                <button data-bs-toggle="modal" data-bs-target="#addBackground" className='fileUpload btn btn-bordered'>Add</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="text-small-gray">Buttons </div>
                                                    <div className="box-edit">
                                                        <div class="bold-gray-title">Submit </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Submit </div>

                                                            <div className="selectBox">
                                                                <div className="select-type d-flex align-items-center">
                                                                    <select className="form-control  ">
                                                                        <option>10</option><option>20</option><option>30</option><option>40</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font color </div>

                                                            <div class="clrPkr">

                                                                <div className="colorPick d-flex align-items-center">
                                                                    <input type="color" className='PickColor' />
                                                                    {/* <input type="color" className='PickColor'   value="#774936" /> */}
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Button color </div>

                                                            <div class="clrPkr">

                                                                <div className="colorPick d-flex align-items-center">
                                                                    <input type="color" className='PickColor' />
                                                                    {/* <input type="color" className='PickColor'   value="#774936" /> */}
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Button Style </div>

                                                            <div className="selectBox">
                                                                <div className="select-type d-flex align-items-center">
                                                                    <select className="form-control  ">
                                                                        <option>Filled</option>
                                                                        <option>Bordered</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="divider-edit"></div>
                                                        <div class="bold-gray-title">Previous </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font size </div>

                                                            <div className="selectBox">
                                                                <div className="select-type d-flex align-items-center">
                                                                    <select className="form-control  ">
                                                                        <option>10</option><option>20</option><option>30</option><option>40</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Button color</div>

                                                            <div class="clrPkr">

                                                                <div className="colorPick d-flex align-items-center">
                                                                    <input type="color" className='PickColor' />
                                                                    {/* <input type="color" className='PickColor'   value="#774936" /> */}
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font color</div>

                                                            <div class="clrPkr">

                                                                <div className="colorPick d-flex align-items-center">
                                                                    <input type="color" className='PickColor' />
                                                                    {/* <input type="color" className='PickColor'   value="#774936" /> */}
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Button Style </div>

                                                            <div className="selectBox">
                                                                <div className="select-type d-flex align-items-center">
                                                                    <select className="form-control  ">
                                                                        <option>Filled</option>
                                                                        <option>Bordered</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="divider-edit"></div>
                                                        <div class="bold-gray-title">Next </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font size </div>

                                                            <div className="selectBox">
                                                                <div className="select-type d-flex align-items-center">
                                                                    <select className="form-control  ">
                                                                        <option>10</option><option>20</option><option>30</option><option>40</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Button color</div>

                                                            <div class="clrPkr">

                                                                <div className="colorPick d-flex align-items-center">
                                                                    <input type="color" className='PickColor' />
                                                                    {/* <input type="color" className='PickColor'   value="#774936" /> */}
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font color</div>

                                                            <div class="clrPkr">

                                                                <div className="colorPick d-flex align-items-center">
                                                                    <input type="color" className='PickColor' />
                                                                    {/* <input type="color" className='PickColor'   value="#774936" /> */}
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Button Style </div>

                                                            <div className="selectBox">
                                                                <div className="select-type d-flex align-items-center">
                                                                    <select className="form-control  ">
                                                                        <option>Filled</option>
                                                                        <option>Bordered</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="text-small-gray">Footer </div>
                                                    <div className="box-edit">
                                                        <div className="footer-editable">
                                                            <EditTextarea
                                                                className="editablesubtitle"
                                                                defaultValue="Enter footer text"
                                                                inputClassName='editablesubtitle'
                                                                rows={1}
                                                                name="survey_description"
                                                                placeholder='Enter footer text'
                                                            />

                                                        </div>
                                                        <div className="divider-edit"></div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font size</div>
                                                            <div class="selectBox">

                                                                <div className="select-type d-flex align-items-center">
                                                                    <select className="form-control fontFamily" >
                                                                        <option>10</option>
                                                                        <option>20</option>
                                                                        <option>30</option>
                                                                        <option>40</option>
                                                                    </select>
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div class="panel-edit d-flex justify-content-between align-items-center">
                                                            <div className="title-small-text">Font color</div>
                                                            <div class="clrPkr">

                                                                <div className="colorPick d-flex align-items-center">
                                                                    <input type="color" className='PickColor' />
                                                                    {/* <input type="color" className='PickColor'   value="#774936" /> */}
                                                                </div>


                                                            </div>
                                                        </div>
                                                        <div className="divider-edit"></div>

                                                    </div>
                                                </div>


                                            </div>


                                            <div className="col-md-6">
                                                <button className="btn btn-bordered  w-100 ">Cancel</button>
                                            </div>
                                            <div className="col-md-6">
                                                <button type="button" className="btn btn-primary add-btn  w-100" data-bs-toggle="modal" data-bs-target="#editPins" srno="1" value="1">Save & Apply</button>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>


                    {/**Right Bar Code */}
                    <div className='flow-grow-1 question-preview-design question-preview-pg design-pg w-100 d-flex flex-column'>
                        <div className="preview-header">
                            <div className="row">
                                <div className="col-lg-2">
                                    <div className="radio-btn-screen d-inline-flex align-items-center justify-content-center">
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="screenSize" id="Desktop" defaultValue="Desktop" defaultChecked />
                                            <label className="form-check-label" htmlFor="Desktop" title="Desktop">
                                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 17H21C22.1046 17 23 16.1046 23 15V5C23 3.89543 22.1046 3 21 3H3C1.89543 3 1 3.89543 1 5V15C1 16.1046 1.89543 17 3 17H12ZM12 17V21M12 21H16M12 21H8" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" />
                                                </svg>


                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="screenSize" id="Tablet" defaultValue="Tablet" />
                                            <label className="form-check-label" htmlFor="Tablet" title="Tablet">
                                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11 18.25C10.5858 18.25 10.25 18.5858 10.25 19C10.25 19.4142 10.5858 19.75 11 19.75V18.25ZM13 19.75C13.4142 19.75 13.75 19.4142 13.75 19C13.75 18.5858 13.4142 18.25 13 18.25V19.75ZM6 1.75H18V0.25H6V1.75ZM19.25 3V21H20.75V3H19.25ZM4.75 21V3H3.25V21H4.75ZM18 22.25H6V23.75H18V22.25ZM11 19.75H13V18.25H11V19.75ZM3.25 21C3.25 22.5188 4.48122 23.75 6 23.75V22.25C5.30964 22.25 4.75 21.6904 4.75 21H3.25ZM19.25 21C19.25 21.6904 18.6904 22.25 18 22.25V23.75C19.5188 23.75 20.75 22.5188 20.75 21H19.25ZM18 1.75C18.6904 1.75 19.25 2.30964 19.25 3H20.75C20.75 1.48122 19.5188 0.25 18 0.25V1.75ZM6 0.25C4.48122 0.25 3.25 1.48122 3.25 3H4.75C4.75 2.30964 5.30964 1.75 6 1.75V0.25Z" fill="#0F2744" />
                                                </svg>
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="screenSize" id="Mobile" defaultValue="Mobile" />
                                            <label className="form-check-label" htmlFor="Mobile" title="Mobile">
                                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11 18.25C10.5858 18.25 10.25 18.5858 10.25 19C10.25 19.4142 10.5858 19.75 11 19.75V18.25ZM13 19.75C13.4142 19.75 13.75 19.4142 13.75 19C13.75 18.5858 13.4142 18.25 13 18.25V19.75ZM8 1.75H16V0.25H8V1.75ZM17.25 3V21H18.75V3H17.25ZM6.75 21V3H5.25V21H6.75ZM16 22.25H8V23.75H16V22.25ZM11 19.75H13V18.25H11V19.75ZM5.25 21C5.25 22.5188 6.48122 23.75 8 23.75V22.25C7.30964 22.25 6.75 21.6904 6.75 21H5.25ZM17.25 21C17.25 21.6904 16.6904 22.25 16 22.25V23.75C17.5188 23.75 18.75 22.5188 18.75 21H17.25ZM16 1.75C16.6904 1.75 17.25 2.30964 17.25 3H18.75C18.75 1.48122 17.5188 0.25 16 0.25V1.75ZM8 0.25C6.48122 0.25 5.25 1.48122 5.25 3H6.75C6.75 2.30964 7.30964 1.75 8 1.75V0.25Z" fill="#0F2744" />
                                                </svg>
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <button className="full-screen-btn" title="View full screen">
                                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14 18V16C14 14.8954 14.8954 14 16 14H18" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M9 6L9 8C9 9.10457 8.10457 10 7 10L5 10" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M5 14L7 14C8.10457 14 9 14.8954 9 16L9 18" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M18 10L16 10C14.8954 10 14 9.10457 14 8L14 6" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex-grow-1 page-content-wrap d-flex flex-column">
                            <div className="title-wrap text-center">
                                <TopHeading />
                            </div>
                            <div className="flex-grow-1">
                                <MultipleQuestions />
                            </div>
                            <PreviewFooter />
                        </div>
                    </div>
                </div>
                <div className="customvar-modal modal fade edit-pop-modal save-design-popup" id="editPins" tabIndex={-1} aria-labelledby="editModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className={"formcontainer" + " " + style.container}>
                                    <div className={"formvawrapper" + " " + style.wrapper}>
                                        <Card view="raised" className={"formstyle p-4" + " " + style.card} >
                                            <Typography
                                                type={device === "mobile" ? "h6" : "h5"}
                                                colorStep={100}
                                                tagName="div"
                                                className={"formhead "}
                                            >
                                                Save your changes to this theme?
                                            </Typography>

                                            <div className="input_with_info ">
                                                <Input
                                                    type="text"
                                                    view="outlined"
                                                    color="default"
                                                    label=""
                                                    // placeholder="Label"
                                                    placeholder={'Copy of rosebud'}
                                                    // value={}
                                                    fill
                                                    className={"formsinput themeName" + " " + style.card__exp}

                                                />
                                            </div>
                                            <div className="button-wrap d-flex justify-content-end">
                                                <button type="button" className="btn btn-bordered" data-bs-dismiss="modal">Discard</button>
                                                <button type="button" className="btn btn-primary ms-3">Save changes</button>
                                            </div>
                                        </Card>
                                    </div >

                                </div >
                            </div>
                        </div>
                    </div>
                </div>

                <div className="customvar-modal modal fade upload-file-modal" id="addFile" tabIndex={-1} aria-labelledby="editModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className={"formcontainer" + " " + style.container}>
                                    <div className={"formvawrapper" + " " + style.wrapper}>
                                        <Card view="raised" className={"formstyle p-4" + " " + style.card} >
                                            <div className="card-heading d-flex justify-content-between">
                                                <h5>Upload logo </h5>
                                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                            </div>
                                            <div className="file-upload-box">
                                                <div className="icon-wrap">
                                                    <Svg name="file-upload" />
                                                </div>
                                                <div className="button-wrap">
                                                    <button type="button" className="btn btn-primary">Upload</button>
                                                </div>
                                                <p>Supported files - <i>JPG, PNG, JPEG, SVG</i></p>
                                            </div>
                                        </Card>
                                    </div >

                                </div >
                            </div>
                        </div>
                    </div>
                </div>


                <div className="customvar-modal modal fade upload-file-modal" id="addBackground" tabIndex={-1} aria-labelledby="editModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className={"formcontainer" + " " + style.container}>
                                    <div className={"formvawrapper" + " " + style.wrapper}>
                                        <Card view="raised" className={"formstyle p-4" + " " + style.card} >
                                            <div className="card-heading">
                                                <h5>Upload Background image</h5>
                                                <p>Note:- Image width should not be less than 1200px</p>
                                            </div>
                                            <div className="file-upload-box">
                                                <div className="icon-wrap">
                                                    <Svg name="file-upload" />
                                                </div>
                                                <div className="button-wrap">
                                                    <button type="button" className="btn btn-primary">Upload</button>
                                                </div>
                                                <p>Supported files - <i>JPG, PNG, JPEG, SVG</i></p>
                                            </div>
                                        </Card>
                                    </div >

                                </div >
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}
